import {
  ComplementActionOrigin,
  ComplementActionType,
} from './WorkOrdersComplements.enums';

export const complementActionLabels: Record<string, string> = {
  [ComplementActionType.Opened]: 'Aberta',
  [ComplementActionType.Authorized]: 'Autorizado',
  [ComplementActionType.Cancelled]: 'Cancelado',
  [ComplementActionType.Closed]: 'Fechado',
  [ComplementActionType.Reopened]: 'Reaberto',
};

export const complementActionColor = {
  [ComplementActionType.Opened]: 'blue',
  [ComplementActionType.Authorized]: 'yellow',
  [ComplementActionType.Cancelled]: 'red',
  [ComplementActionType.Closed]: 'green',
  [ComplementActionType.Reopened]: 'blue',
};

export const complementActionOriginLabels: Record<string, string> = {
  [ComplementActionOrigin.Internal]: 'Interno',
  [ComplementActionOrigin.PortoSchedule]: 'Agenda Porto',
  [ComplementActionOrigin.PortoBattery]: 'Bateria Porto',
  [ComplementActionOrigin.MyBcs]: 'My BCS',
  [ComplementActionOrigin.Activity]: 'Atividade',
  [ComplementActionOrigin.CheckList]: 'Checklist',
  [ComplementActionOrigin.Public]: 'Público',
};

export const complementActionOriginColor: Record<string, string> = {
  [ComplementActionOrigin.Internal]: 'default',
  [ComplementActionOrigin.PortoSchedule]: 'blue',
  [ComplementActionOrigin.PortoBattery]: 'cyan',
  [ComplementActionOrigin.MyBcs]: 'purple',
  [ComplementActionOrigin.Activity]: 'yellow',
  [ComplementActionOrigin.CheckList]: 'orange',
  [ComplementActionOrigin.Public]: 'green',
};
